import { useState } from 'react'

const MediaWithShimmer = ({
  src,
  type,
  className = '',
  wrapperClassName = '',
  eager = false,
  ...rest
}) => {
  const [imageError, setImageError] = useState(false)
  
  const combinedClassName = [wrapperClassName, className].filter(Boolean).join(' ')
  
  // Auto-detect video by file extension if type not specified
  const isVideo = type === 'video' || (src && /\.(mp4|webm|ogg|mov)$/i.test(src))

  // Use proxy for external images (VK, bogacheli.com, etc.)
  const getProxiedUrl = (url) => {
    if (!url) return url
    
    // Check if it's an external URL that needs proxying
    const isExternal = url.startsWith('http://') || url.startsWith('https://')
    const isOwnDomain = url.includes('aalriche.com') || url.includes('vercel.app')
    
    if (isExternal && !isOwnDomain) {
      const proxied = `/api/image-proxy?url=${encodeURIComponent(url)}`
      console.log('Proxying image:', url, '→', proxied)
      return proxied
    }
    
    return url
  }

  const proxiedSrc = getProxiedUrl(src)

  if (isVideo) {
    return (
      <video
        src={proxiedSrc}
        muted={rest.muted ?? true}
        autoPlay={rest.autoPlay ?? true}
        loop={rest.loop ?? true}
        playsInline={rest.playsInline ?? true}
        {...rest}
        className={combinedClassName}
      />
    )
  }

  // Show placeholder if image failed to load
  if (imageError || !src) {
    return (
      <div className={`${combinedClassName} bg-gray-200 flex items-center justify-center`}>
        <i className="ri-image-line text-4xl text-gray-400"></i>
      </div>
    )
  }

  return (
    <img
      src={proxiedSrc}
      alt={rest.alt || ''}
      className={combinedClassName}
      onError={(e) => {
        console.error('Image failed to load:', src, e)
        setImageError(true)
      }}
    />
  )
}

export default MediaWithShimmer
